"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var FlagsPopover = function (_a) {
    var company = _a.company;
    var _b = __read(react_1.default.useState(null), 2), flagPopover = _b[0], setFlagPopover = _b[1];
    var handleFlagsPopover = function (event) {
        setFlagPopover(flagPopover ? null : event.currentTarget);
    };
    var _c = __read((0, hooks_1.useSubmitter)('companies', company.id), 2), updateCompany = _c[0], isUpdatingCompany = _c[1];
    var flagToggler = function (flag) { return function () {
        var _a;
        return updateCompany((_a = {}, _a[flag] = !company[flag], _a));
    }; };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleFlagsPopover }, { children: "Flags" })), (0, jsx_runtime_1.jsx)(material_1.Popover, __assign({ open: !!flagPopover, anchorEl: flagPopover, onClose: function () { return setFlagPopover(null); }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ p: 2, maxWidth: 900 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 1 }, { children: [interfaces_1.companyTempFlags.map(function (flag) {
                                var timestampField = "".concat(flag, "StartedAt");
                                var timestamp = company[timestampField];
                                return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ md: 4, item: true }, { children: [(0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2, mb: 1 }, { children: [flag, ": ", company[flag] ? 'ON' : 'OFF'] })), (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrimSm, __assign({ onClick: flagToggler(flag), isSending: isUpdatingCompany }, { children: "Switch" })), timestamp && (0, jsx_runtime_1.jsxs)("small", { children: ["ON since ", timestamp.toDate().toLocaleString()] })] }), flag));
                            }), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ md: 4, item: true }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, mb: 1 }, { children: "Switch all off" })), (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPink, __assign({ onClick: function () { return updateCompany(Object.fromEntries(interfaces_1.companyTempFlags.map(function (f) { return [f, false]; }))); }, isSending: isUpdatingCompany, disabled: interfaces_1.companyTempFlags.every(function (f) { return !company[f]; }) }, { children: "Switch all off" }))] }))] })) })) }))] }));
};
exports.default = FlagsPopover;
